import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import ReactDataTable from "../../../Common/ReactDataTable";

const FundTransferList = () => {
  const [transferData, setTransferData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const fetchData = async () => {
    setLoading(true);

    try {
      const res = await Http.get(`/accounts/fund-transfers`);
      const resRole = await Http.get(`/staff-type-check`);
      setTransferData(res.data);
      setRole(resRole.data);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);

  const cols = [
    { field: "date", header: "Date" },
    { field: "from_account.name", header: "From Account" },
    { field: "to_account.name", header: "To Account" },
    { field: "amount", header: "Amount" },
    { field: "reference", header: "Reference" },
    { field: "status", header: "  Status  " }
  ];

  const actionTemplate = (item) => {
    return (
      <td className="text-xs text-center">
        <Link
          to={`/view-fund-transfer/${item.id}`}
          className="btn btn-info btn-sm ms-1"
          title="View Fund Transfer"
        >
          <i className="fa fa-list" aria-hidden="true"></i>
        </Link>
        {(role === "admin" || role === "supply_chain") && (
          <Link
            to={`/edit-fund-transfer/${item.id}`}
            className="btn btn-primary btn-sm ml-1"
            title="Edit"
          >
            <i className="fa fa-pencil" aria-hidden="true"></i>
          </Link>
        )}
      </td>
    );
  };

  return (
    <div>
      <IsLogin></IsLogin>
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">All Fund Transfers</h5>
            <div className="am-right">
              {(role === "admin" || role === "supply_chain") && (
                <Link
                  to="/create-fund-transfer"
                  className="btn btn-primary"
                >
                  <i className="fa fa-plus"></i> Add New Fund Transfer
                </Link>
              )}
            </div>
          </div>

          <div className="am-pagebody">
            <Alert alert={alert} />

            <div className="card pd-20 pd-sm-40">
              <ReactDataTable
                cols={cols}
                receiveData={transferData}
                isLoading={loading}
                actionTemplate={actionTemplate}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FundTransferList;